/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Matrix_AriaInputs */

const cs_portals_matrix_aria = /** @type {(inputs: Portals_Matrix_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Požadavky portálů`)
};

const en_portals_matrix_aria = /** @type {(inputs: Portals_Matrix_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portal field requirements`)
};

/**
* | output |
* | --- |
* | "Portal field requirements" |
*
* @param {Portals_Matrix_AriaInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_matrix_aria = /** @type {((inputs?: Portals_Matrix_AriaInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Matrix_AriaInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_matrix_aria(inputs)
	return cs_portals_matrix_aria(inputs)
});